import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CancelModalComponent } from '../cancel-modal/cancel-modal.component';
import { AssigmentShiftSummaryCalculationComponent } from '../../../../shared/components/assigment-shift-summary-calculation/assigment-shift-summary-calculation.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GuardDetailsModalComponent } from '../../../../shared/components/guard-details-modal/guard-details-modal.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromApp from "../../../../store/app.reducer"
import * as AssignmentsActions from "../../store/assignments.actions";
import { CommonConstants } from '../../../../constants/common-constant';
import { CalendarDataRefreshService } from '../../../../services/calendar-data-refresh.service';
import moment from 'moment';
import { getSelectedShift } from '../../store/assignment.selector';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { CommonService } from 'src/app/services/common.service';
import { LoadingService } from 'src/app/service/loading-service.service';
import { firstValueFrom, take } from 'rxjs';
import { NgZone } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer.model';
import { SnackbarService } from 'src/app/shared/snackbar/snackbar.service';
@Component({
  imports: [AssigmentShiftSummaryCalculationComponent, TranslateModule, CommonModule, ReactiveFormsModule, CurrencyFormatPipe],
  selector: 'app-published-shift-modal',
  templateUrl: './published-shift-modal.component.html',
  styleUrls: ['./published-shift-modal.component.scss'],
  standalone: true
})
export class PublishedShiftModalComponent implements OnInit, OnDestroy {
  isCancelModal: boolean = false;
  isReadyShift: boolean = false;
  isPublishShift: boolean = false;
  isOngoingShift: boolean = false;
  public customer: CustomerModel;
  shiftData: any;
  form: FormGroup;
  commonConstants = CommonConstants
  isShowEditDescriptionSection: boolean = false
  guardCount: number = this.data?.guardsNumber || 1;
  showPlusBox: boolean = false;
  showMinusBox: boolean = false;
  readonly MIN_GUARDS = 1;
  isShowJobDescriptionEditButton: boolean = false
  isShowtimeShiftSection: boolean = false
  isShowShiftButton: boolean = false
  isShowAddGuardBookedPanel: boolean = false
  updateShiftHoursForm: FormGroup;
  durationInHours: number | null = null;
  isShiftInvalid = false;
  durationDisplay: string = '';
  shiftData$: any
  private hasDataChanged: boolean = false; // Track if any data has been modified
  private hasExplicitRefreshTriggered: boolean = false; // Track if we already triggered refresh explicitly
  totalCost: any
  customerId: any
  subscription: any

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private store: Store<fromApp.AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PublishedShiftModalComponent>,
    private calendarDataRefreshService: CalendarDataRefreshService,
    public currencyFormatPipe: CurrencyFormatPipe,
    private cdr: ChangeDetectorRef,
    private service: CommonService,
    private loadingService: LoadingService,
    private ngZone: NgZone,
    private translate: TranslateService,
    private snackbarService: SnackbarService
  ) {
    this.isCancelModal = data?.isCancel || false;
    this.isReadyShift = data?.isReadyShift || false;
    this.isPublishShift = data?.isPublishShift || false;
    this.isOngoingShift = data?.isOngoingShift || false
  }

  async ngOnInit(): Promise<void> {
    this.subscription = this.store.subscribe(appState => {
      this.customer = appState.auth.customer;
    });

    try {
      // ✅ Step 1: Initialize base data
      this.shiftData = this.data;

      // ✅ Step 2: Wait for customerId from the store
      const authState = await firstValueFrom(this.store.select(state => state.auth));
      this.customerId = authState?.customer?.id;

      if (!this.customerId) {
        console.error('Customer ID not found.');
        return;
      }
      // ✅ Step 3: Fetch shift details by customerId and shiftId
      await this.loadShiftDetails();

      // ✅ Step 4: Initialize forms and computed values
      this.initializeForms();
      this.patchgetDate();

      // ✅ Step 5: Setup observable subscription for live updates
      this.shiftData$ = this.store.select(getSelectedShift);
      this.shiftData$.pipe(take(1)).subscribe(shiftData => {
        if (shiftData) {
          this.totalCost = shiftData.totalCost;
          this.getGuardChangeData(shiftData, shiftData.guardsNumber);
          this.cdr.markForCheck();
        }
      });

    } catch (error) {
      console.error("Error during initialization:", error);
    }
  }

  ngOnDestroy() {
    if (this.hasDataChanged && !this.hasExplicitRefreshTriggered) {
      this.calendarDataRefreshService.triggerRefresh('shift_updated', this.shiftData?.id);
    }
  }

  // Increment decrement fucntion for ready and publish modal start
  increaseGuardCount() {
    this.guardCount++;
    this.showPlusBox = true;
    this.showMinusBox = false;
  }

  decreaseGuardCount() {
    if (this.guardCount > this.MIN_GUARDS) {
      this.guardCount--;
      this.showMinusBox = true;
      this.showPlusBox = false;
      if (this.guardCount <= this.shiftData?.guardsNumber) {
        this.dismissCount();
      }
    }
  }

  cancelChange() {
    this.guardCount = this.shiftData?.guardsNumber || 1;
    this.showPlusBox = false;
    this.showMinusBox = false;
  }

  saveGuardCount() {
    this.guardCount
    const payload = {
      id: this.shiftData.id,
      numberOfGuards: this.guardCount
    };
    this.store.dispatch(new AssignmentsActions.UpdateShift(payload));
    // Calculate totalCost: duration * guards * costPerGuard
    const newTotalCost = (this.shiftData?.duration || 0) * this.guardCount * (this.shiftData?.costPerGuard || 0);
    this.shiftData = {
      ...this.shiftData,
      guardsNumber: this.guardCount,
      totalCost: newTotalCost
    };
    this.showPlusBox = false;
    this.showMinusBox = false;

    // Trigger calendar refresh immediately and reset flag to prevent duplicate calls
    this.calendarDataRefreshService.triggerRefresh('guard_count_updated', this.shiftData?.id);
    this.hasDataChanged = false; // Reset flag since we already triggered refresh
  }

  dismissCount() {
    this.guardCount = this.shiftData?.guardsNumber
    this.totalCost = this.shiftData?.totalCost
    this.showPlusBox = false;
    this.showMinusBox = false;
  }

  // Job description function start
  editJobDscription() {
    this.isShowEditDescriptionSection = true;
    this.isShowJobDescriptionEditButton = true;
    this.form.get('description')?.setValue(this.shiftData?.description || '');
  }

  saveDescription() {
    if (this.form.invalid) return;
    this.shiftData.description = this.form.value.description;
    this.isShowEditDescriptionSection = false;
    this.isShowJobDescriptionEditButton = false;
    // Get the latest description value from the form
    const descriptionValue = this.form.get('description')?.value;
    // Prepare payload
    const payload = {
      id: this.shiftData?.id,
      description: descriptionValue
    };
    // Dispatch the action with updated payload
    this.store.dispatch(new AssignmentsActions.UpdateShift(payload));
    this.shiftData = {
      ...this.shiftData,
      description: this.form.get('description')?.value
    }

    // Trigger calendar refresh immediately and reset flag to prevent duplicate calls
    this.calendarDataRefreshService.triggerRefresh('description_updated', this.shiftData?.id);
    this.hasDataChanged = false; // Reset flag since we already triggered refresh
  }

  cancelEdit() {
    this.isShowEditDescriptionSection = false;
    this.isShowJobDescriptionEditButton = false;
    this.form.reset({ description: this.shiftData?.description });
  }

  get description() {
    return this.form.get('description');
  }

  displayStatus = (status: number | null | undefined) => {
    if (typeof status === 'number') {
      return this.translate.instant(`shift-status.${status}`) || this.translate.instant('shift-status.unknown');
    }
    return this.translate.instant('shift-status.unknown');
  };

  // Shift detail time change  function start
  editshifttime() {
    this.isShowtimeShiftSection = true;
    this.isShowShiftButton = true;
  }

  onTimeChange() {
    const startTime = this.updateShiftHoursForm.get('startTime')?.value;
    const endTime = this.updateShiftHoursForm.get('endTime')?.value;

    if (startTime && endTime) {
      const start = this.parseTime(startTime);
      const end = this.parseTime(endTime);

      let diffMs = end.getTime() - start.getTime();

      // Handle overnight shifts
      if (diffMs < 0) {
        diffMs += 24 * 60 * 60 * 1000; // add 24 hours
      }

      const totalMinutes = Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      this.durationInHours = totalMinutes / 60;

      // Get translated strings dynamically based on current language
      const hourText = this.translate.instant(hours === 1 ? 'time.hour' : 'time.hours');
      const minuteText = this.translate.instant(minutes === 1 ? 'time.minute' : 'time.minutes');

      // Show only one language at a time
      this.durationDisplay = `${hours} ${hourText} ${minutes} ${minuteText}`;

      // Mark invalid if less or equal 0 or greater than 13
      this.isShiftInvalid = this.durationInHours > 13 || this.durationInHours < 0;
    } else {
      this.durationInHours = null;
      this.durationDisplay = '';
      this.isShiftInvalid = false;
    }
  }

  parseTime(timeStr: string): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  saveShiftTime() {
    this.isShowtimeShiftSection = false;
    this.isShowShiftButton = false;

    const startTimeValue = this.updateShiftHoursForm.get('startTime')?.value;
    const endTimeValue = this.updateShiftHoursForm.get('endTime')?.value;

    // Parse startAt and endAt in **local time first**
    let startAtLocal = moment(`${this.shiftData?.startAt?.split('T')[0]}T${startTimeValue}`, 'YYYY-MM-DDTHH:mm');
    let endAtLocal = moment(`${this.shiftData.startAt.split('T')[0]}T${endTimeValue}`, 'YYYY-MM-DDTHH:mm');

    // If end before start, push to next day
    if (startAtLocal.isAfter(endAtLocal)) {
      endAtLocal.add(1, 'days');
    }

    // Convert to UTC
    const startAtUtc = startAtLocal.utc();
    const endAtUtc = endAtLocal.utc();

    // Calculate duration in minutes
    const durationInMinutes = endAtUtc.diff(startAtUtc, 'minutes');
    // Convert to hours to match the existing system format
    const duration = durationInMinutes / 60;

    const payload = {
      id: this.shiftData?.id,
      startAt: startAtUtc.toISOString(), // UTC ISO string
      endAt: endAtUtc.toISOString(),     // UTC ISO string
      duration: duration,
      description: this.shiftData?.description
    };

    // Dispatch action
    this.store.dispatch(new AssignmentsActions.UpdateShift(payload));

    // Update local shiftData
    this.shiftData = {
      ...this.shiftData,
      startTime: startTimeValue,
      endTime: endTimeValue,
      startAt: startAtUtc.toISOString(),
      endAt: endAtUtc.toISOString(),
      duration: duration
    };

    // Update the form with the new values so they appear when editing again
    this.updateShiftHoursForm.patchValue({
      startTime: startTimeValue,
      endTime: endTimeValue
    });
    this.loadShiftDetails();
    // Trigger calendar refresh immediately and reset flag to prevent duplicate calls
    this.calendarDataRefreshService.triggerRefresh('time_updated', this.shiftData?.id);
    this.hasDataChanged = false; // Reset flag since we already triggered refresh
  }

  cancelShiftTime() {
    // Hide the edit section
    this.isShowtimeShiftSection = false;
    this.isShowShiftButton = false;

    if (this.shiftData) {
      // Reset form to API values
      this.updateShiftHoursForm.patchValue({
        startTime: this.shiftData?.startTime,
        endTime: this.shiftData?.endTime
      });

      // Recalculate duration based on original API values
      if (this.shiftData?.startTime && this.shiftData?.endTime) {
        const start = this.parseTime(this.shiftData?.startTime);
        const end = this.parseTime(this.shiftData?.endTime);

        let diffMs = end.getTime() - start.getTime();
        if (diffMs < 0) {
          diffMs += 24 * 60 * 60 * 1000;
        }

        const totalMinutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        this.durationInHours = totalMinutes / 60;
        this.durationDisplay = `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        this.isShiftInvalid = this.durationInHours > 13 || this.durationInHours < 0;
      } else {
        this.durationInHours = null;
        this.durationDisplay = '';
        this.isShiftInvalid = false;
      }
    }
  }

  // Open booked guard pane for booked guard section start
  opneBookGuardPanel() {
    this.isShowAddGuardBookedPanel = true
  }

  hideBookGuardPanel() {
    this.isShowAddGuardBookedPanel = false
  }

  async bookedGuard(guardData: any) {
    // Check if shift is already fully staffed
    if (this.shiftData?.guardsNumber === this.shiftData?.guardsHiredCount) {
      this.hideBookGuardPanel();
      return;
    }

    this.loadingService.showLoader();

    try {
      // Make API call directly to handle success/error properly
      const response: any = await firstValueFrom(
        this.service.acceptGuardForShift(this.shiftData?.id, guardData.id)
      );

      // Only update local data on API success
      if (response && response.data) {
        this.shiftData = {
          ...this.shiftData,
          guardsHiredCount: this.shiftData?.guardsHiredCount + 1,
          guardsAppliedCount: this.shiftData?.guardsAppliedCount - 1,
          hired: [...this.shiftData?.hired, guardData],
          applied: this.shiftData?.applied.filter((g: any) => g.id !== guardData.id)
        };

        // Trigger calendar refresh
        this.calendarDataRefreshService.triggerRefresh('guard_booked', this.shiftData?.id);
        this.hasDataChanged = false;

        // Show success message
        this.snackbarService.showSuccess(this.translate.instant('guards-picked'));
      }
    } catch (error: any) {
      // Show error message - do NOT update hired array
      if (error.status === 400 && error.error?.message) {
        this.snackbarService.showError(error.error.message);
      } else {
        this.snackbarService.showError(this.translate.instant('something-went-wrong'));
      }
    } finally {
      this.loadingService.hideLoader();
    }
  }

  // Other Functions Start
  patchgetDate() {
    this.updateShiftHoursForm.patchValue({
      startTime: this.shiftData?.startTime || '16:00',
      endTime: this.shiftData?.endTime || '20:00'
    });
  }

  closeModal(): void {
    // send success flag when closing
    this.dialogRef.close({ success: true });
  }

  openCancelModal(): void {
    const dialogRef = this.dialog.open(CancelModalComponent, {
      width: '500px',
      disableClose: false,
      data: { isCancel: true, shiftId: this.shiftData?.id }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success || result === true) {
        // ✅ Trigger refresh immediately before closing dialog
        this.hasExplicitRefreshTriggered = true;
        this.calendarDataRefreshService.triggerRefresh('shift_deleted', this.shiftData?.id);
        this.hasDataChanged = false;

        // ✅ Close parent dialog
        this.dialogRef.close({ success: true });
      }
    });
  }

  showGuardDetails(guardDetails: any) {
    this.dialog.open(GuardDetailsModalComponent, {
      data: guardDetails
    });
  }

  getGuardChangeData(shiftData: any, guardCount: number) {
    // Calculate totalCost: duration * guards * costPerGuard
    const duration = shiftData?.duration || 0;
    const costPerGuard = shiftData?.costPerGuard || 0;
    const totalCostPerGuard = costPerGuard / duration;
    const numericCost = totalCostPerGuard * guardCount * duration;
    return {
      oldCount: shiftData?.guardsNumber,
      newCount: guardCount,
      cost: numericCost, // numeric, for calculations
      formattedCost: this.currencyFormatPipe.transform(numericCost) // string, for display
    };
  }

  private async loadShiftDetails(): Promise<void> {
    this.loadingService.showLoader();
    try {
      const response: any = await firstValueFrom(
        this.service.getShiftDetailsById(this.customerId, this.shiftData?.id)
      );
      this.shiftData = response.data;
      this.totalCost = this.shiftData?.totalCost;
    } catch (error) {
      console.error("Error fetching shift details:", error);
    } finally {
      this.loadingService.hideLoader();
    }
  }

  private initializeForms(): void {
    this.form = this.fb.group({
      description: [this.shiftData?.description || '']
    });

    this.updateShiftHoursForm = this.fb.group({
      startTime: [''],
      endTime: ['']
    });
  }
}